/**
 * Insights panel. Deterministic v0; future hookup to on-device LLM via
 * chassis/llm.ts. Renders cards with severity-coded borders.
 */
import { withVault, injectCommonStyles, escapeHtml } from './_shared.ts';
import { deterministicInsights } from '../chassis/llm.ts';

const TPL = /* html */ `
<style>
.cards { display: grid; gap: 10px; margin-top: 14px; }
.card {
  padding: 14px 16px;
  background: var(--parchment);
  border: 1px solid var(--rule-hair);
  border-left: 3px solid var(--indigo);
  border-radius: 2px;
  display: grid;
  gap: 4px;
}
.card.urgent { border-left-color: var(--crimson); background: oklch(48% 0.180 25 / 0.04); }
.card.attention { border-left-color: var(--saffron-deep); background: oklch(70% 0.150 78 / 0.06); }
.card.info { border-left-color: var(--leaf); }
.card .title {
  font-family: var(--display);
  font-weight: 600;
  font-size: 15px;
  color: var(--ink);
}
.card .body {
  font-family: var(--display);
  font-style: italic;
  color: var(--ink-dim);
  line-height: 1.45;
  font-size: 14px;
}
</style>
<section class="frame">
  <h2>Insights <span class="deva">सूझ</span></h2>
  <div class="kicker">What your vault is missing, why it matters</div>
  <div class="cards" id="cards"></div>
</section>
`;

export class WasiyatInsights extends HTMLElement {
  #shadow = this.attachShadow({ mode: 'open' });
  #unsub: (() => void) | null = null;

  connectedCallback(): void {
    injectCommonStyles(this.#shadow);
    this.#shadow.innerHTML += TPL;
    this.#unsub = withVault(this, (v, root) => {
      const cards = root.getElementById('cards');
      if (!cards) return;
      const items = deterministicInsights(v);
      cards.innerHTML = items.map((c) => `<div class="card ${c.severity}">
        <div class="title">${escapeHtml(c.title)}</div>
        <div class="body">${escapeHtml(c.body)}</div>
      </div>`).join('');
    });
  }
  disconnectedCallback(): void { this.#unsub?.(); }
}

customElements.define('wasiyat-insights', WasiyatInsights);
